import React from "react";

export const ErrorCard: React.FC = () => {
  return (
    <div className="h-[14.688rem] min-w-[10.938rem] rounded-2xl bg-red-100 flex items-center justify-center text-red-500">
      Error
    </div>
  );
};